import styled, { css, keyframes } from "styled-components";
import { Box } from "@vinomofo/components";
import { COLORS, FONT_FAMILIES } from "../../styles";

const { dmSans } = FONT_FAMILIES;

const slideUp = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

const DigitContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  gap: 0.1em;
`;

const Digit = styled(Box)<{ animate: boolean }>`
  font-family: ${dmSans};
  font-size: 210px;
  font-weight: bold;
  color: ${COLORS.white};
  line-height: 1;
  position: relative;
  overflow: hidden;
  width: 0.65em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  will-change: transform;

  @media ${({ theme }) => theme.mq.max.tablet} {
    font-size: 150px;
    width: 0.65em;
  }

  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 70px;
    width: 0.65em;
  }

  ${({ animate }) =>
    animate &&
    css`
      animation: ${slideUp} 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    `}
`;

const CounterPlusSign = styled(Box)`
  font-size: 180px;
  font-weight: bold;
  color: ${COLORS.white};
  align-self: flex-start;
  opacity: 0;
  animation: fadeIn 1s ease-out forwards;
  animation-delay: 0.6s;

  @media ${({ theme }) => theme.mq.max.tablet} {
    font-size: 110px;
  }

  @media ${({ theme }) => theme.mq.max.mobile} {
    font-size: 60px;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

interface AnimatedDigitsProps {
  displayNumber: string;
  animate: boolean;
}

export const AnimatedDigits = ({
  displayNumber,
  animate,
}: AnimatedDigitsProps) => {
  if (displayNumber === "0") return null;

  return (
    <DigitContainer>
      {displayNumber.split("").map((digit, index) => (
        <Digit key={`digit-${index}`} animate={animate} as="span">
          {digit}
        </Digit>
      ))}
      <CounterPlusSign as="span">+</CounterPlusSign>
    </DigitContainer>
  );
};
